"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (email) {
    return (/\S+@\S+\.\S+/.test(email)
    );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/misc/isValidEmail.js
// module id = 623
// module chunks = 0